<!--首页-->
<template>
  <div  >
 <img style="width:100%;margin:0" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230721/user-0/20230721/1458dd179cf6e30a4f9e1b216e80ab6a.jpg?x-oss-process=style/tb-750" />
    <!-- <img style="width:100%;margin:0" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230721/user-0/20230721/492a9c3d8220166be1810f9ecfc19648.jpg?x-oss-process=style/tb-750" /> -->
     </div> 
</template>
<style scoped>  
</style>

<script> 

export default {
  name: "Index",
  components: { 
  },
  data: function() {
    return { 
    };
  },
  filter: {},
  mounted() {
    document.title = "升级中"; 

  },
  destroyed() {},
  methods: { 
  }
};
</script>



// WEBPACK FOOTER //
// update.vue?19a30893